import React from 'react';

import { MostPopularArticle } from '../../interfaces/homepage';
import ArticleItem from './ArticleItem';
import MostPopularArticlesHeader from './Header';

interface MostPopularArticlesProps {
  className?: string;
  mostPopularArticles: MostPopularArticle[];
}

const TITLE = 'Most Popular';

const MostPopularArticles = ({ className, mostPopularArticles }: MostPopularArticlesProps) => {
  return (
    <aside className={className}>
      <MostPopularArticlesHeader title={TITLE} />
      <ul className="m-0 list-none p-0">
        {mostPopularArticles.map((article, index) => (
          <ArticleItem key={`${article.slug}-${index}`} {...article} index={index} />
        ))}
      </ul>
    </aside>
  );
};

export default MostPopularArticles;
